"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _stylesModule = _interopRequireDefault(require("@components/Layout/Container/styles.module.scss"));

var _scss = require("@scss");

var _getDataProps = _interopRequireDefault(require("@utils/getDataProps"));

var _excluded = ["children", "animate", "style", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Col = /*#__PURE__*/(0, _react.forwardRef)(function Col(_ref, ref) {
  var _getCssProp$split$map, _getCssProp$split$map2, _getCssProp$split$map3;

  var children = _ref.children,
      animate = _ref.animate,
      style = _ref.style,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var colClass = (_getCssProp$split$map = (0, _scss.getCssProp)(props, 'col').split(' ').map(function (cx) {
    return _stylesModule["default"][cx.trim()];
  })) !== null && _getCssProp$split$map !== void 0 ? _getCssProp$split$map : [];
  var offsetClass = (_getCssProp$split$map2 = (0, _scss.getCssProp)(props, 'offset').split(' ').map(function (cx) {
    return _stylesModule["default"][cx.trim()];
  })) !== null && _getCssProp$split$map2 !== void 0 ? _getCssProp$split$map2 : [];
  var orderClass = (_getCssProp$split$map3 = (0, _scss.getCssProp)(props, 'order').split(' ').map(function (cx) {
    return _stylesModule["default"][cx.trim()];
  })) !== null && _getCssProp$split$map3 !== void 0 ? _getCssProp$split$map3 : [];
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    ref: ref
  }, (0, _getDataProps["default"])(props), {
    className: (0, _scss.cls)(_stylesModule["default"]['col'], _stylesModule["default"]['col-gutter'], colClass, orderClass, offsetClass, className)
  }, animate, {
    style: style
  }), children);
});
var _default = Col;
exports["default"] = _default;